import { useState } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import { usePlayer } from "@/lib/player";
import PageBanner from "@/components/site/PageBanner";
import SectionTitle from "@/components/site/SectionTitle";

const empty = { current: "", new: "", new2: "" };

function PasswordForm() {
  const [form, setForm] = useState(empty);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/player/password", form);
      toast.success("Hasło zostało zmienione");
      setForm(empty);
    } catch (err) { setError(errorText(err)); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="password-form">
      <label className="block"><span className="text-xs text-slate-400">Obecne hasło</span>
        <input type="password" autoComplete="current-password" className="steel-input" value={form.current} onChange={set("current")} data-testid="pw-current" /></label>
      <label className="block"><span className="text-xs text-slate-400">Nowe hasło (6-16 znaków, bez polskich liter)</span>
        <input type="password" autoComplete="new-password" className="steel-input" value={form.new} onChange={set("new")} data-testid="pw-new" /></label>
      <label className="block"><span className="text-xs text-slate-400">Powtórz nowe hasło</span>
        <input type="password" autoComplete="new-password" className="steel-input" value={form.new2} onChange={set("new2")} data-testid="pw-new2" /></label>
      {error && <p className="text-sm text-red-300" data-testid="pw-error">{error}</p>}
      <button disabled={busy || !form.current || !form.new || !form.new2} className="btn btn-primary w-full" data-testid="pw-submit-btn">
        {busy ? "Zapisywanie..." : "Zmień hasło"}
      </button>
    </form>
  );
}

export default function PlayerPanel() {
  const { player, logout } = usePlayer();
  if (player === undefined) return <div className="min-h-[60vh]" />;
  if (!player) return <Navigate to="/" replace />;

  return (
    <div className="relative pt-16">
      <PageBanner />
      <section className="relative py-20 px-6 md:px-10 max-w-6xl mx-auto" data-testid="player-panel">
        <SectionTitle kicker="Twoje konto" title="Panel gracza" />
        <div className="grid lg:grid-cols-[280px_1fr] gap-6 items-start">
          <div className="steel-panel chamfer"><div className="steel-inner chamfer p-6">
            <h3 className="font-display text-lg text-slate-100">Konto</h3>
            <div className="mt-3 flex justify-between py-2 border-b border-white/5 text-sm"><span className="text-slate-400">Login</span><b className="text-slate-100" data-testid="panel-login">{player.login}</b></div>
            <div className="flex justify-between py-2 border-b border-white/5 text-sm"><span className="text-slate-400">Postaci</span><b className="text-slate-100">{player.characters.length}</b></div>
            <button onClick={logout} className="btn w-full mt-5" data-testid="panel-logout-btn">Wyloguj</button>
          </div></div>
          <div className="space-y-6">
            <div className="steel-panel chamfer"><div className="steel-inner chamfer p-6">
              <h3 className="font-display text-lg text-slate-100 mb-4">Postacie</h3>
              {!player.characters.length && <p className="text-slate-500 text-sm" data-testid="panel-no-chars">Brak postaci na tym koncie.</p>}
              {player.characters.map((c) => (
                <div key={c.name} className="flex items-center justify-between border border-[#2c2f52] bg-[#0a0c1e] rounded-md px-4 py-3 mb-2" data-testid={`panel-char-${c.name}`}>
                  <div><b className="text-slate-100">{c.name}</b><div className="text-xs text-slate-400">{c.job}{c.guild ? ` · gildia ${c.guild}` : ""}</div></div>
                  <b className="text-amber-300">Poz. {c.level}</b>
                </div>
              ))}
            </div></div>
            <div className="steel-panel chamfer"><div className="steel-inner chamfer p-6">
              <h3 className="font-display text-lg text-slate-100 mb-4">Zmiana hasła</h3>
              <PasswordForm />
            </div></div>
          </div>
        </div>
      </section>
    </div>
  );
}
